<template>
  <v-container fluid>
    <v-card class="mb-3" v-show="!loading">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Cadastro de Cliente</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="mr-2"
          color="primary lighten-3"
          @click="$router.push('/clientes')"
          :disabled="salvando_cliente"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary lighten-4"
          :disabled="!form_valid"
          :loading="salvando_cliente"
          @click="salvarCliente"
          >Salvar</v-btn
        >
      </v-app-bar>
      <v-form ref="form_cliente" v-model="form_valid" lazy-validation>
        <v-container fluid>
          <v-row dense v-if="!cliente.id">
            <v-col cols="12" sm="6">
              <v-text-field
                label="Razão Social"
                ref="cliente_razao_social"
                v-model="cliente.razao_social"
                autofocus
                @keypress.native.enter="$refs.cliente_nome_fantasia.focus()"
                :rules="regras_cliente.razao_social"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Nome de Fantasia"
                ref="cliente_nome_fantasia"
                v-model="cliente.nome_fantasia"
                @keypress.native.enter="$refs.responsavel_nome.focus()"
                :rules="regras_cliente.nome_fantasia"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense v-else>
            <v-col cols="12" sm="12">
              <v-text-field
                label="Nome"
                ref="nome"
                v-model="cliente.nome"
                autofocus
                @keypress.native.enter="$refs.responsavel_nome.focus()"
                :rules="regras_cliente.razao_social"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Nome do Responsável"
                ref="responsavel_nome"
                v-model="cliente.responsavel_nome"
                @keypress.native.enter="$refs.responsavel_cpf.focus()"
                :rules="regras_cliente.responsavel_nome"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                label="CPF do Responsável"
                ref="responsavel_cpf"
                v-model="cliente.responsavel_cpf"
                v-mask="'###.###.###-##'"
                :return-masked-value="true"
                :rules="regras_cliente.cpf"
                @keypress.native.enter="$refs.cnpj.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3" v-if="!cliente.id">
              <v-text-field
                label="CNPJ"
                ref="cliente_cnpj"
                v-model="cliente.cnpj"
                @keypress.native.enter="$refs.cliente_ie.focus()"
                :rules="regras_cliente.cnpj"
                v-mask="'##.###.###/####-##'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" v-if="!cliente.id">
              <v-text-field
                label="Inscrição Estadual"
                ref="cliente_ie"
                v-model="cliente.ie"
                @keypress.native.enter="$cliente.cliente_rua.focus()"
                :rules="regras_cliente.ie"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              v-if="
                (cliente.id && user.tipo == 'representante') ||
                  user.tipo == 'master'
              "
            >
              <v-text-field
                label="Email"
                v-model="cliente.user.email"
                :disabled="user.tipo !== 'master'"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense v-if="!cliente.id || user.tipo == 'master'">
            <v-col cols="12" sm="6">
              <v-text-field
                label="Logradouro"
                ref="cliente_rua"
                v-model="cliente.endereco.rua"
                @keypress.native.enter="$refs.cliente_numero.focus()"
                :rules="regras_cliente.rua"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                label="Número"
                ref="cliente_numero"
                v-model="cliente.endereco.numero"
                @keypress.native.enter="$refs.cliente_complemento.focus()"
                :rules="regras_cliente.numero"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Complemento"
                ref="cliente_complemento"
                v-model="cliente.endereco.complemento"
                @keypress.native.enter="$refs.cliente_bairro.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="!cliente.id || user.tipo == 'master'">
            <v-col cols="12" sm="4">
              <v-text-field
                label="Bairro"
                ref="cliente_bairro"
                v-model="cliente.endereco.bairro"
                @keypress.native.enter="$refs.cliente_estado_id.focus()"
                :rules="regras_cliente.bairro"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="cliente.endereco.estado_id"
                ref="cliente_estado_id"
                :items="estados"
                label="Estado"
                @change="getCidadesCliente"
                @keypress.native.enter="$refs.cliente_cidade_id.focus()"
                :rules="regras_cliente.estado"
                autocomplete="off"
                role="presentation"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="cliente.endereco.cidade_id"
                ref="cliente_cidade_id"
                :items="cidades_cliente"
                label="Cidade"
                @keypress.native.enter="$refs.cliente_cep.focus()"
                :rules="regras_cliente.cidade"
                :loading="load_cidade_cliente"
                autocomplete="off"
                role="presentation"
              />
            </v-col>
          </v-row>
          <v-row dense v-if="!cliente.id || user.tipo == 'master'">
            <v-col cols="12" sm="4">
              <v-text-field
                label="CEP"
                ref="cliente_cep"
                v-model="cliente.endereco.cep"
                @keypress.native.enter="$refs.cliente_telefone.focus()"
                :rules="regras_cliente.cep"
                v-mask="'##.###-###'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Telefone"
                ref="cliente_telefone"
                v-model="cliente.endereco.telefone"
                @keypress.native.enter="$refs.cliente_celular.focus()"
                v-mask="'(##) ####-####'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Celular"
                ref="cliente_celular"
                v-model="cliente.endereco.celular"
                @keypress.native.enter="$refs.cliente_email.focus()"
                v-mask="'(##) #####-####'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="4" v-if="!cliente.id">
              <v-text-field
                label="Email"
                ref="cliente_email"
                v-model="cliente.endereco.email"
                :rules="regras_cliente.email"
                @blur="setarEmailUser"
                @keypress.native.enter="$refs.user_senha.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" v-if="!cliente.id && user.tipo != 'fornecedor'">
              <v-text-field
                label="Senha"
                ref="user_senha"
                v-model="cliente.user.password"
                :rules="regras_cliente.password"
                type="password"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" v-if="user.tipo == 'master'">
              <v-autocomplete
                v-model="cliente.representante_id"
                ref="representante_id"
                :items="representantes"
                label="Representante"
                :rules="regras_cliente.representante"
                clearable
                autocomplete="off"
                role="presentation"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>

    <v-card v-if="cliente.id">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Lojas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          fab
          small
          color="primary lighten-4"
          class="mr-2"
          @click="tooglePesquisa"
        >
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn depressed color="primary lighten-4" @click="abrirDialogoLojas"
          >Adicionar</v-btn
        >
      </v-app-bar>
      <v-expand-transition>
        <v-row dense v-show="exibirPesquisa" class="pa-2">
          <v-col cols="12" pa-2>
            <v-text-field
              ref="pesquisa"
              label="Pesquisa"
              v-model="pesquisa"
              prepend-inner-icon="search"
              solo
              background-color="grey lighten-2"
              clearable
              single-line
              hide-details
              placeholder="Pesquisa"
              color="primary"
              @click:clear="tooglePesquisa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-divider />

      <v-data-table
        :search="pesquisa"
        :headers="header_lojas"
        :items="lojas"
        hide-default-footer
        :loading="loading"
      >
        <template v-slot:item.acoes="{ item }">
          <td class="justify-center layout px-0">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="editarLoja(item)">
                  <v-list-item-title>
                    <v-icon class="mr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoExcluirLoja(item)">
                  <v-list-item-title>
                    <v-icon class="mr-4">close</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <as-dialogo
      ref="dialogoLojas"
      title="Cadastro de Loja"
      max-width="1200px"
      semPadding
      hideCloseButton
      hideDivider
    >
      <v-form ref="formLojas" v-model="form_valid_lojas" lazy-validation>
        <v-container fluid>
          <v-row dense>
            <v-col sm6>
              <v-text-field
                label="Razão Social"
                ref="razao_social"
                v-model="loja.razao_social"
                @keypress.native.enter="$refs.nome_fantasia.focus()"
                :rules="regras_loja.razao_social"
                autofocus
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm6>
              <v-text-field
                label="Nome Fantasia"
                ref="nome_fantasia"
                v-model="loja.nome_fantasia"
                @keypress.native.enter="$refs.cnpj.focus()"
                :rules="regras_loja.nome_fantasia"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col sm6>
              <v-text-field
                label="CNPJ"
                ref="cnpj"
                v-model="loja.cnpj"
                @keypress.native.enter="$refs.ie.focus()"
                :rules="regras_loja.cnpj"
                v-mask="'##.###.###/####-##'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm6>
              <v-text-field
                label="Inscrição Estadual"
                ref="ie"
                v-model="loja.ie"
                @keypress.native.enter="$refs.rua.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col sm4>
              <v-text-field
                label="Logradouro"
                ref="rua"
                v-model="loja.endereco.rua"
                @keypress.native.enter="$refs.numero.focus()"
                :rules="regras_loja.rua"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm2>
              <v-text-field
                label="Número"
                ref="numero"
                v-model="loja.endereco.numero"
                @keypress.native.enter="$refs.complemento.focus()"
                :rules="regras_loja.numero"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm3>
              <v-text-field
                label="Complemento"
                ref="complemento"
                v-model="loja.endereco.complemento"
                @keypress.native.enter="$refs.bairro.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm3>
              <v-text-field
                label="Bairro"
                ref="bairro"
                v-model="loja.endereco.bairro"
                @keypress.native.enter="$refs.estado_id.focus()"
                :rules="regras_loja.bairro"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col sm6>
              <v-autocomplete
                v-model="loja.endereco.estado_id"
                ref="estado_id"
                :items="estados"
                label="Estado"
                @change="getCidadesLoja"
                @keypress.native.enter="$refs.cidade_id.focus()"
                :rules="regras_loja.estado"
                autocomplete="off"
                role="presentation"
              />
            </v-col>
            <v-col sm6>
              <v-autocomplete
                v-model="loja.endereco.cidade_id"
                ref="cidade_id"
                :items="cidades"
                label="Cidade"
                @keypress.native.enter="$refs.cep.focus()"
                :rules="regras_loja.cidade"
                :loading="load_cidade_loja"
                autocomplete="off"
                role="presentation"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col sm2>
              <v-text-field
                label="CEP"
                ref="cep"
                v-model="loja.endereco.cep"
                @keypress.native.enter="$refs.telefone.focus()"
                :rules="regras_loja.cep"
                v-mask="'##.###-###'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm3>
              <v-text-field
                label="Telefone"
                ref="telefone"
                v-model="loja.endereco.telefone"
                @keypress.native.enter="$refs.celular.focus()"
                v-mask="'(##) ####-####'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm3>
              <v-text-field
                label="Celular"
                ref="celular"
                v-model="loja.endereco.celular"
                @keypress.native.enter="$refs.email.focus()"
                v-mask="'(##) #####-####'"
                :return-masked-value="true"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col sm4>
              <v-text-field
                label="Email"
                ref="email"
                v-model="loja.endereco.email"
                :rules="regras_loja.email"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <div slot="botoes">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoLojas.fechar()"
          :disabled="salvando_loja"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="salvarLoja"
          :loading="salvando_loja"
          :disabled="salvando_loja || !form_valid_lojas"
          >Salvar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoExcluirLoja"
      title="Excluir"
      max-width="440px"
      hideCloseButton
      hideDivider
    >
      <v-label>Deseja excluir esta loja?</v-label>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluirLoja.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluirLoja"
          :disabled="excluindo_loja"
          :loading="excluindo_loja"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>

    <v-row v-show="loading" class="justify-center align-center mt-5">
      <v-progress-circular
        indeterminate
        size="50"
        width="3"
        color="primary"
      ></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
import Services from "@/services/services.js";
import ServiceLojas from "@/services/lojas.js";
import ServiceClientes from "@/services/clientes.js";
import ServiceAdministrador from "@/services/administradores.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "ClientesForm",
  mixins: [validadores],
  data() {
    return {
      user: {},
      exibirPesquisa: false,
      loading: false,
      form_valid: false,
      form_valid_lojas: false,
      salvando_cliente: false,
      salvando_loja: false,
      load_cidade_loja: false,
      excluindo_loja: false,
      pesquisa: "",
      cliente: {
        nome: "",
        razao_social: "",
        nome_fantasia: "",
        responsavel_nome: "",
        responsavel_cpf: "",
        representante_id: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        user: {
          email: "",
          password: "",
        },
      },
      loja: {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      regras_loja: {
        razao_social: [(value) => !!value || "Campo obrigatório"],
        nome_fantasia: [(value) => !!value || "Campo obrigatório"],
        cnpj: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarCNPJ(value) || "CNPJ Inválido",
        ],
        rua: [(value) => !!value || "Campo obrigatório"],
        numero: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cep: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        email: [
          (value) =>
            value ? this.validarEmail(value) || "Email Inválido" : true,
        ],
      },
      regras_cliente: {
        razao_social: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        nome_fantasia: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        responsavel_nome: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        cnpj: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
          (value) => this.validarCNPJ(value) || "CNPJ Inválido",
        ],
        cpf: [
          (value) => (value ? this.validarCPF(value) || "CPF Inválido" : true),
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        representante: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        rua: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        numero: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        bairro: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        cidade: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        estado: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        cep: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        telefone: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        email: [
          (value) =>
            value ? this.validarEmail(value) || "Email Inválido" : true,
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
        password: [
          (value) =>
            !!value ||
            (this.$auth.user.tipo !== "master" ? "Campo obrigatório" : true),
        ],
      },
      estados: Services.estados(),
      cidades: [],
      lojas: [],
      header_lojas: [
        { text: "Nome Fantasia", value: "nome_fantasia", width: "30%" },
        { text: "Razão Social", value: "razao_social", width: "30%" },
        { text: "CNPJ", value: "cnpj", width: "20%" },
        { text: "Local", value: "endereco.local", width: "15%" },
        { text: "", value: "acoes", width: "5%", sortable: false },
      ],
      representantes: [],
      load_cidade_cliente: false,
      cidades_cliente: [],
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.params.cliente_id) {
      this.editar(this.$route.params.cliente_id);
    }

    if (this.user.tipo == "administrador" || this.user.tipo == "master") {
      this.getRepresentantes();
    }
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async editar(cliente_id) {
      try {
        this.loading = true;
        let cliente = await ServiceClientes.editar(cliente_id);
        this.cliente = cliente.data.cliente;

        this.getCidadesCliente();
        this.listarLojas();
      } catch (error) {
        console.log(error);
        this.$eventbus.error("Erro ao editar cliente", error);
      } finally {
        this.loading = false;
      }
    },
    async listarLojas() {
      try {
        let lojas = await ServiceClientes.listarLojas(this.cliente.id);
        this.lojas = lojas.data.lojas;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar lojas");
      }
    },
    async salvarCliente() {
      if (this.$refs.form_cliente.validate()) {
        let err = null;
        try {
          this.salvando_cliente = true;

          if (this.cliente.id) {
            await ServiceClientes.atualizar(this.cliente);
            this.$eventbus.notificar("Cliente atualizado com sucesso");
          } else {
            await ServiceClientes.salvar({
              ...this.cliente,
              nome: this.cliente.nome_fantasia,
              representante_id:
                this.$auth.user.representante_id ||
                this.cliente.representante_id,
            });
            this.$eventbus.notificar("Cliente salvo com sucesso");
          }
        } catch (error) {
          err = error;
          this.$eventbus.erro(
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.msg +
                "<br/><small>Verifique se o cliente já encontra-se cadastrado <br/>ou fale com o administrador do naModa.com.vc</small>") ||
              "Erro ao salvar cliente"
          );
        } finally {
          this.salvando_cliente = false;
          if (!err) {
            this.$router.push("/clientes");
          }
        }
      }
    },
    editarLoja(loja) {
      this.loja = this.clone(loja);
      this.getCidadesLoja();
      this.$refs.dialogoLojas.abrir();
    },
    abrirDialogoLojas() {
      this.loja = {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      };
      // this.$refs.formLojas.reset();
      setTimeout(() => {
        this.$refs.razao_social.focus();
      }, 500);
      this.$refs.dialogoLojas.abrir();
    },
    async salvarLoja() {
      if (this.$refs.formLojas.validate()) {
        try {
          this.salvando_loja = true;

          let response = "";
          if (this.loja.id) {
            delete this.loja.endereco.local;
            response = await ServiceClientes.atualizarLoja(
              this.cliente.id,
              this.loja
            );
          } else {
            response = await ServiceClientes.salvarLoja(
              this.cliente.id,
              this.loja
            );
          }

          this.$eventbus.notificar(response.data.msg);
          this.listarLojas();
          this.$refs.dialogoLojas.fechar();
        } catch (error) {
          console.log(error);
          this.$eventbus.erro(error.response.data.msg);
        } finally {
          this.salvando_loja = false;
        }
      }
    },
    abrirDialogoExcluirLoja(loja) {
      this.loja = this.clone(loja);
      this.$refs.dialogoExcluirLoja.abrir();
    },
    async excluirLoja() {
      try {
        this.excluindo_loja = true;
        let response = await ServiceClientes.excluirLoja(
          this.cliente.id,
          this.loja
        );

        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.listarLojas();
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.excluindo_loja = false;
        this.$refs.dialogoExcluirLoja.fechar();
      }
    },
    async getCidadesLoja() {
      try {
        this.load_cidade_loja = true;
        let response = await Services.cidades(this.loja.endereco.estado_id);
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar cidades");
      } finally {
        this.load_cidade_loja = false;
      }
    },
    async getCidadesCliente() {
      try {
        this.load_cidade_cliente = true;
        let response = await Services.cidades(this.cliente.endereco.estado_id);
        this.cidades_cliente = response.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar cidades");
      } finally {
        this.load_cidade_cliente = false;
      }
    },
    async getRepresentantes() {
      let representantes = await ServiceAdministrador.carregarRepresentantes();
      this.representantes = representantes.data.representantes;
    },
    setarEmailUser() {
      this.cliente.user.email = this.cliente.endereco.email;
    },
    setarEmailEndereco() {
      this.cliente.endereco.email = this.cliente.user.email;
    },
  },
};
</script>

<style></style>
